import React from 'react';
import Slider from 'react-slick';
import { useGetBlogPostsQuery } from '../../../redux/slices/blogPostSlice';

import BlogPostTease from './BlogPostTease';

import styles from '../FeaturedTrucks.module.postcss';

const defaultSettings = {
  slidesToShow: 4,
  slidesToScroll: 2,
  infinite: false,
  lazyLoad: 'anticipated',
  waitForAnimate: false,
  useCSS: true,
  useTransform: true,
  responsive: [
    {
      breakpoint: 1350,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 732,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

function FeaturedBlogPostsScroll({ title }) {
  const { data = {} } = useGetBlogPostsQuery({ published: true, page_size: 8 });
  const blogPosts = data.blog_posts || [];

  if (!blogPosts || blogPosts.length < 1) {
    return null;
  }

  const slides = blogPosts.map((blogPost) => {
    return (
      <div key={'vendors-' + blogPost.id}>
        <BlogPostTease blogPost={blogPost} />
      </div>
    );
  });

  return (
    <div>
      <h2>{ title || 'Recent Posts'}</h2>
      <Slider className={styles.FeaturedTrucks} {...defaultSettings}>
        {slides}
      </Slider>
    </div>
  );
}

export default FeaturedBlogPostsScroll;
